document.addEventListener("DOMContentLoaded", () => {
  const storageKey = "COOKIE_BANNER_CLICKED";
  const isClickedBefore = localStorage.getItem(storageKey);
  const cookieBanner = document.querySelector(".cookie-banner");

  // Show the banner only if it hasn't been clicked before
  if (!isClickedBefore) {
    cookieBanner.classList.add("visible");

    const cookieBannerButtons = document.querySelectorAll(".bnr-btn");
    cookieBannerButtons.forEach((button) => {
      button.addEventListener("click", () => {
        cookieBanner.classList.remove("visible");
        localStorage.setItem(storageKey, "true");
      });
    });
  }
});

// console.log("success");
gtag("consent", "default", {
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
  analytics_storage: "granted",
});
